import axios from "axios";
import Vue from "vue";
import store from "../store";
import router from "../router";

var mainBaseUrl = process.env.NODE_ENV === "production" ? "" : "/szuser";
var qrUserUrl = process.env.NODE_ENV === "production" ? "" : "/qrUser";
var userBaseUrl =
  process.env.NODE_ENV === "production" ? "/skynotice" : "/userBaseUrl";
var researchBaseUrl =
  process.env.NODE_ENV === "production"
    ? "/research_system"
    : "/researchBaseUrl/research_system";
var peixunBaseUrl =
  process.env.NODE_ENV === "production"
    ? "/skytraining"
    : "/peixunBaseUrl/skytraining";

// process.env.NODE_ENV === 'production' ? '/sz_city_school' : '/citySchool'
// var userBaseUrl = process.env.NODE_ENV === 'production' ? '/idc' : '/api10200'

axios.defaults.timeout = 500000;
axios.defaults.baseURL = userBaseUrl;

//request拦截
axios.interceptors.request.use(
  (config) => {
    if (localStorage.getItem("token") != null) {
      config.headers = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);
//response拦截
axios.interceptors.response.use((response) => {
  return response;
});
//get请求
var get = ({
  baseurl = false,
  url,
  data = {},
  success,
  fail = defaultFailControl,
  final,
  isUrl = "",
}) => {
  if (isUrl == "mainBaseUrl") {
    axios.defaults.baseURL = mainBaseUrl;
  } else if (isUrl == "researchBaseUrl") {
    axios.defaults.baseURL = researchBaseUrl;
  } else if (isUrl == "peixunBaseUrl") {
    axios.defaults.baseURL = peixunBaseUrl;
  } else {
    axios.defaults.baseURL = userBaseUrl;
  }

  // if (baseurl) {
  //   axios.defaults.baseURL = userBaseUrl
  // }else{
  //   axios.defaults.baseURL = mainBaseUrl
  // }
  //网络请求
  var promise = new Promise((resolve, reject) => {
    axios
      .get(url, { params: data })
      .then(
        (response) => {
          response && resolve(response.data);
          // if (response.data.code == 200||response.data.code == 'ok' ) {
          //   response && resolve(response.data)

          // } else if(response.data.code == 1002){
          //   Vue.prototype.$message({
          //     showClose: true,
          //     message: response.data.message,
          //     type: 'error',
          //   })
          // }else{
          //   Vue.prototype.$message({
          //     showClose: true,
          //     message: response.data.msg,
          //     type: 'error',
          //   })
          // }
        },
        (err) => {
          reject(err);
          defaultErrorControl(err, fail);
        }
      )
      .finally(() => {
        final && final();
      });
  });
  dealResponse(promise, success, fail);
};

//post请求
var post = ({
  baseurl,
  url,
  isForm = false,
  data = {},
  success,
  fail = defaultFailControl,
  final,
  isUrl = "",
}) => {
  if (isUrl == "mainBaseUrl") {
    axios.defaults.baseURL = mainBaseUrl;
  } else if (isUrl == "researchBaseUrl") {
    axios.defaults.baseURL = researchBaseUrl;
  } else if (isUrl == "peixunBaseUrl") {
    axios.defaults.baseURL = peixunBaseUrl;
  } else if (isUrl == "qrUserUrl") {
    axios.defaults.baseURL = qrUserUrl;
  } else {
    axios.defaults.baseURL = userBaseUrl;
  }
  //判断是否是formData
  var params;
  if (isForm) {
    params = new FormData();
    for (let i in data) {
      params.append(i, data[i]);
    }
  } else {
    params = data;
  }

  //网络请求
  var promise = new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then(
        (response) => {
          // if (baseurl) {
          //   axios.defaults.baseURL = mainBaseUrl
          // }
          resolve(response.data);
        },
        (err) => {
          reject(err);
          defaultErrorControl(err, fail);
        }
      )
      .finally(() => {
        final && final();
      });
  });
  dealResponse(promise, success, fail);
};

//put请求
var put = ({ url, data = {}, success, fail = defaultFailControl }) => {
  //网络请求
  var promise = new Promise((resolve, reject) => {
    axios.put(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
        defaultErrorControl(err, fail);
      }
    );
  });
  dealResponse(promise, success, fail);
};

//patch请求
var patch = ({ url, data = {}, success, fail = defaultFailControl }) => {
  //网络请求
  var promise = new Promise((resolve, reject) => {
    axios.patch(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
        defaultErrorControl(err, fail);
      }
    );
  });
  dealResponse(promise, success, fail);
};

//delete
var deleteReq = ({ url, data = {}, success, fail = defaultFailControl }) => {
  //网络请求
  var promise = new Promise((resolve, reject) => {
    axios.delete(url, { params: data }).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
        defaultErrorControl(err, fail);
      }
    );
  });
  dealResponse(promise, success, fail);
};

var dealResponse = (promise, success, fail) => {
  //请求结果处理
  promise.then((response) => {
    if (
      response.code == undefined ||
      response.code == "ok" ||
      response.code == 0 ||
      response.code == 200
    ) {
      success && success(response);
    } else if (response.code == 1402) {
      Vue.prototype.$message({
        showClose: true,
        message: "未登录或者已过期，请重新登陆",
        type: "error",
      });
      localStorage.removeItem("currentRole");
      router.push({ path: "/login" });
    } else if (response.code == 1002) {
      Vue.prototype.$message({
        showClose: true,
        message: response.message,
        type: "error",
      });
    } else {
      fail(response.msg, response);
    }
  });
};

var defaultErrorControl = (err, fail) => {
  var status = err.response.status;
  if (status == 403) {
    Vue.prototype.$notify.warning("没有相关权限");
    //  localStorage.removeItem('token')

    // router.replace('/login')
    setTimeout(() => {
      window.location.href = "/";
    }, 1000);
  } else if (status == 401) {
    Vue.prototype.$notify.warning("暂未登陆或者token过期");
    // localStorage.removeItem('token')

    // router.replace('/login')
    setTimeout(() => {
      window.location.href = "/";
    }, 1000);
  } else {
    fail("网络错误");
  }
};

var defaultFailControl = (response) => {
  Vue.prototype.$notify.error({ title: response });
};

//文件导出
var download = ({
  url,
  data,
  name,
  success = undefined,
  fail = defaultFailControl,
  final = undefined,
}) => {
  var promise = new Promise((resolve, reject) => {
    axios
      .post(url, data, {
        responseType: "blob",
      })
      .then(
        (response) => {
          resolve(response.data);
        },
        (err) => {
          reject(err);
          defaultErrorControl(err, fail);
        }
      )
      .finally(() => {
        final && final();
      });
  });
  promise.then((response) => {
    if (response.size == 0) {
      Vue.prototype.$notify.warning({ title: "当前数据为空" });
      return;
    }
    if (response.size < 15) {
      Vue.prototype.$notify.warning({ title: "当前无权限" });
      return;
    }
    if (success != undefined) {
      success();
      return;
    }
    let blobData = new Blob([success], {
      type: "application/vnd.ms-excel",
    }); // 创建 Blob 对象
    let dowloadUrl = window.URL.createObjectURL(blobData); // 创建下载链接
    let link = document.createElement("a");
    link.style.display = "none";
    link.href = dowloadUrl;
    link.setAttribute("download", name);
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(dowloadUrl);
    document.body.removeChild(link);
  });
};

//文件下载
var downloadFile = ({ url, name, isUrl = "" }) => {
  if (isUrl == "mainBaseUrl") {
    axios.defaults.baseURL = mainBaseUrl;
  } else if (isUrl == "researchBaseUrl") {
    axios.defaults.baseURL = researchBaseUrl;
  } else if (isUrl == "peixunBaseUrl") {
    axios.defaults.baseURL = peixunBaseUrl;
  } else if (isUrl == "qrUserUrl") {
    axios.defaults.baseURL = qrUserUrl;
  } else {
    axios.defaults.baseURL = userBaseUrl;
  }
  // axios.defaults.baseURL = baseUrl
  var promise = new Promise((resolve, reject) => {
    axios
      .get(url, {
        responseType: "blob",
      })
      .then(
        (response) => {
          resolve(response.data);
        },
        (err) => {
          reject(err);
        }
      );
  });
  promise.then((response) => {
    let dowloadUrl = window.URL.createObjectURL(new Blob([response]));
    let link = document.createElement("a");
    link.style.display = "none";
    link.href = dowloadUrl;
    link.setAttribute("download", name);
    document.body.appendChild(link);
    link.click();
  });
};

// 获取表格
var getExcel = ({
  url,
  method = "post",
  data = {},
  success,
  fail = defaultFailControl,
  isDownload = false,
  name,
}) => {
  //网络请求
  var promise = new Promise((resolve, reject) => {
    axios[method](url, data, {
      responseType: "blob",
    }).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
        defaultErrorControl(err, fail);
      }
    );
  });
  dealResponse(promise, success, fail);
  promise.then((success) => {
    if (isDownload) {
      let blobData = new Blob([success], {
        type: "application/vnd.ms-excel",
      }); // 创建 Blob 对象
      let dowloadUrl = window.URL.createObjectURL(blobData); // 创建下载链接
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = dowloadUrl;
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
      // 释放之前的URL对象
      window.URL.revokeObjectURL(dowloadUrl);
      // 从dom中移除该a链接
      document.body.removeChild(link);
    }
  });
};
//获得压缩包
var getZip = ({
  url,
  method = "post",
  data = {},
  success,
  fail = defaultFailControl,
  name,
}) => {
  //网络请求
  var promise = new Promise((resolve, reject) => {
    axios[method](url, data, {
      responseType: "blob",
    }).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
        defaultErrorControl(err, fail);
      }
    );
  });
  dealResponse(promise, success, fail);
  promise.then((success) => {
    let blobData = new Blob([success], {
      type: "application/zip",
    }); // 创建 Blob 对象
    let dowloadUrl = window.URL.createObjectURL(blobData); // 创建下载链接
    let link = document.createElement("a");
    link.style.display = "none";
    link.href = dowloadUrl;
    link.setAttribute("download", name);
    document.body.appendChild(link);
    link.click();
    // 释放之前的URL对象
    window.URL.revokeObjectURL(dowloadUrl);
    // 从dom中移除该a链接
    document.body.removeChild(link);
  });
};

export default {
  get,
  post,
  put,
  patch,
  deleteReq,
  download,
  downloadFile,
  getExcel,
  getZip,
};
